<template>
  <div style="width:100%;height:100%;background:#151515">
     <el-row style="width:100%;height:50px">
     </el-row>
    <el-row style="width:100%;height:calc(100% - 50px);overflow:auto">
      <el-form :rules="rules" ref="project" label-position="right"  label-width="100px" :model="project">
        <el-form-item style="color:#ffffff" label="项目名称"  prop="name">
          <el-input style="width:70%;float:left" v-model="project.aio_project_name"></el-input>
        </el-form-item>
        <el-form-item label="项目地址">
          <el-input style="width:70%;float:left" v-model="project.address"></el-input>
        </el-form-item>
        <el-form-item label="BIM设计案例">
          <el-input style="width:70%;float:left" v-model="project.aio_case">
            <template slot="prepend">Http://</template>
          </el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="mobile">
          <el-input style="width:70%;float:left" v-model="project.aio_mobile" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="地址查询" style="text-align:left" >
          <el-input v-model="search"  id="pickerInput" style="width:40rem;"></el-input>
          <div id="map" style="width: 40rem; height: 20rem;margin-top:20px; border: 2px solid #cccccc;"></div>
        </el-form-item>
        <el-form-item label="封面">
          <el-upload 
            style="text-align:left"
              class="avatar-uploader"
              :action="UploadUrl()"
              name="upload"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload">
              <img  v-if="project.saaspic" :src="'https://resource.mibee.cn/resource/' + project.saaspic" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>                
        </el-form-item>
        <el-form-item label="项目施工图片">
          <el-upload
            style="text-align:left"
            class="avatar-uploader1"
            :action="UploadUrlPic()"
            list-type="picture-card"
            :file-list="AioPic"
            name="upload"
            :on-success="handleAvatarSuccessPic"
            :before-upload="beforeAvatarUploadPic"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove">
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
        <el-form-item v-if="project.protocolid===227" label="参数隐藏" style="text-align:left;color:#aaaaaa" >
          <el-checkbox style="color:#ffffff" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
        <el-checkbox-group v-model="project.aiodp" @change="handleCheckedCitiesChange">
          <el-checkbox @change="$forceUpdate()" style="color:#ffffff" v-for="dp in dplist" :label="dp.tag" :key="dp.tag">{{dp.desc}}</el-checkbox>
        </el-checkbox-group>
        *设置参数隐藏后，需刷新页面展示效果
        </el-form-item>
        <el-form-item>
          <el-button type="warning" @click="save()">保存</el-button>
        </el-form-item>
      </el-form>   
    </el-row>
  </div>
</template>

<script>
import Vue from "vue";
let map;
let marker = null;
export default {
  name: "Report",
  data() {
    var mobileCheck = (tule, value, callback) => {
      if (value&&(value.length != 11 || value[0] != 1)) {
          callback(new Error("请输入正确的手机号"));
      } else {
          callback();
      }
    };
    return {
      project:{aiodp:[]},
      checkAll:false,
      dplist:[{tag:'acb',desc:'耗电监控'},{tag:'in',desc:'室外进风'},{tag:'out',desc:'室外排风'},{tag:'roomin',desc:'室内送风'},{tag:'roomout',desc:'室内回风'},{tag:'fjjqgr',desc:'经济器过热度'},{tag:'reg0046',desc:'经济器出口'},{tag:'reg0045',desc:'经济器进口'}],
      search:'',
      filename:'',
      filenameAio: '',
      AioPic: [],
      isIndeterminate: true,
      rules: {
        name: [
          { required: true, message: '请输入项目名称', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        mobile: [
          { required: false, message: "请输入手机号", trigger: "blur" },
          { validator: mobileCheck, trigger: "blur" },
        ],
      },
      dialogImageUrl: '',
      dialogVisible: false
    }
  },
  computed:{
 
  },
  mounted: function () {
    let project=window.localStorage.getItem('project')
    if(project){
      this.project=JSON.parse(project)
      if(!this.project.aio_project_name){
        this.project.aio_project_name=this.project.name
      }
      
      if(this.project.aio_pic) {
        this.project.aio_pic = JSON.parse(this.project.aio_pic)
        for(let i = 0; i < this.project.aio_pic.length; i++) {
          let a = {url: 'https://resource.mibee.cn/resource/' + this.project.aio_pic[i], name: 'AioPic'}
          this.AioPic.push(a)
        }
      }else {
        this.project.aio_pic = []
      }

      if(this.project.aiodp){
        //this.project.aiodp=JSON.parse(this.project.aiodp)
      }else{
        this.project.aiodp=[]
      }
      this.ditu()
    }else{
       this.$router.push({ name: "Login" });
    }
   },
  methods: {
    ditu() {
        var self = this;
      
        //初始化
        var geocoder = new AMap.Geocoder({
            radius: 500, //范围，默认：500
        });
        map = new AMap.Map("map", {
            zoom: 12, //缩放比例
            center: this.project.location ? JSON.parse('['+this.project.location+']') : null,
        });
        if (this.project.location) {

                if (marker != null) {
                    map.remove(marker);
                    marker=null
                }
                marker = new AMap.Marker();
                marker.setMap(map);
                marker.setPosition(JSON.parse('['+this.project.location+']'));

            }
            map.on('click', function (ev) {
                var tar = ev.lnglat;
                if (marker != null) {
                    map.remove(marker);
                      marker=null
                }
                marker = new AMap.Marker();
                marker.setMap(map);
                marker.setPosition(tar);

                geocoder.getAddress(tar, function (status, result) {
                    if (status === 'complete' && result.regeocode) {
                        var address = result.regeocode.formattedAddress;
                        self.project.location = JSON.stringify(tar).replace(/\[/g,'').replace(/\]/g,'');
                        self.project.address = address.substr(address.indexOf('省')+1,999);;
                    } else {
                          self.$message({
                    showClose: true,
                    message: "根据经纬度查询地址失败",
                    type: "error",
                  });
                    }
                })



            })
        AMapUI.loadUI(['misc/PoiPicker'], function(PoiPicker) {

            var poiPicker = new PoiPicker({
                input: 'pickerInput'
            });

            //初始化poiPicker
            poiPickerReady(poiPicker);
        });

        function poiPickerReady(poiPicker) {
            window.poiPicker = poiPicker;
            //选取了某个POI
            poiPicker.on('poiPicked', function(poiResult) {
                console.log(poiResult)
                var poi = poiResult.item
                if (!!!poi.location) {
                    self.$message({
                    showClose: true,
                    message: "您输入的信息没有明确的地址信息",
                    type: "error",
                  });
                    return;
                }
                  var poi = poiResult.item;

                if (marker != null) {
                    map.remove(marker);
                    marker=null
                }
                marker = new AMap.Marker();
                marker.setMap(map);
                marker.setPosition(poi.location);
                  geocoder.getAddress(poi.location, function (status, result) {
                    if (status === 'complete' && result.regeocode) {
                        var address = result.regeocode.formattedAddress;
                        self.project.location = JSON.stringify(poi.location).replace(/\[/g,'').replace(/\]/g,'');
                          self.project.address = address.substr(address.indexOf('省')+1,999);
                    } else {
                          self.$message({
                    showClose: true,
                    message: "根据经纬度查询地址失败",
                    type: "error",
                  });
                    }
                })
                // marker = new AMap.Marker();
                // marker.setMap(map);
                // infoWindow.setMap(map);
                // marker.setPosition(poi.location);
                // self.project.location = JSON.stringify(poi.location).replace(/\[/g,'').replace(/\]/g,'');
                //  self.project.address= poi.address
                // infoWindow.setPosition(poi.location);
                // infoWindow.setContent('地址信息: <pre>' + poi.address + '</pre>');
                // infoWindow.open(map, marker.getPosition());
            });
        } 
    },
    save:function(){
        if(Array.isArray(this.project.aio_pic)) {
          this.project.aio_pic = JSON.stringify(this.project.aio_pic)
        }
        console.log(this.project.aio_pic)
        this.$refs['project'].validate((valid) => {
          if (valid) {
             Vue.axios
        .post("/project/update", this.project)
        .then((res) => {
          if (res.data.errcode == 0) {
              this.$message({
              showClose: true,
              message: '保存成功',
              type: "success",
            });
            window.localStorage.setItem('project',JSON.stringify(this.project))
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg,
              type: "error",
            });
          }
        });
  

          } else {
            console.log('error submit!!');
            return false;
          }
        });
    },
    handleAvatarSuccess(response) {
      this.project.saaspic = response.uuid;
      this.$forceUpdate()
    },
    handleAvatarSuccessPic(response) {
      this.project.aio_pic.push(response.uuid);
      console.log(this.project.aio_pic)
      // this.project.aio_pic = JSON.stringify(this.project.aio_pic)
      this.$forceUpdate()
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      this.filename = file.name
      
      if (!isLt2M) {
      this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    beforeAvatarUploadPic(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      console.log(file)
      this.filenameAio = file.name
      
      if (!isLt2M) {
      this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    UploadUrl() {
      let filename = this.filename
      let actionUrl ='https://resource.mibee.cn/resource/upload?isauth=0&type=2&program_type=BASE&filename=' + filename;//接口地址
      return actionUrl
    },
    UploadUrlPic() {
      let filename = this.filenameAio
      let actionUrl1 ='https://resource.mibee.cn/resource/upload?isauth=0&type=2&program_type=BASE&filename=' + filename;//接口地址
      return actionUrl1
    },
    handleCheckAllChange(val) {
      this.project.aiodp = val ? this.dplist.map(d=>{return d.tag}) : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.dplist.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.dplist.length;
    },

    handleRemove(file, fileList) {
      if(file.name != 'AioPic') {
        this.project.aio_pic = this.project.aio_pic.filter((x) => {
          return x != file.response.uuid
        })
      }else {
        this.project.aio_pic = this.project.aio_pic.filter((x) => {
          return x != file.url.split('https://resource.mibee.cn/resource/')[1]
        })
      }
      
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.el-form-item__label{
  color:#ffffff
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader1 .el-upload {
    border: 1px dashed #d9d9d9;
    background-color: transparent;
    width: 130px;
    height: 130px;
    line-height: 130px;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader1 .el-upload:hover {
    border-color: #409EFF;
  }
  .el-upload-list--picture-card .el-upload-list__item {
    width: 130px;
    height: 130px;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 130px;
    height: 130px;
    line-height: 130px;
    text-align: center;
  }
  .avatar {
    width: 130px;
    height: 130px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/Devices/Setup.vue